import Vue from 'vue'
import DesignedButton from './DesignedButton' 

Vue.component('DesignedButton', DesignedButton)




// WEBPACK FOOTER //
// ./src/components/ui/index.js